import i18n from '@/locale';

export default {
	emptyRules: (v) => !!v || i18n.t('error.requiredField'),
	emptyRuleWithParams: (isSubmitted, content) => [v => !isSubmitted || !!v || content],
	emptyArrayRules: (v) => (!!v && v.length !== 0) || i18n.t('error.requiredField'),
	emptyArrayRuleWithParams: (isSubmitted, content) => [v => !isSubmitted || (!!v && v.length !== 0) || content],
	minLengthRules: (v) => (!v || v.length >= 6) || i18n.t('error.minLength', { number: 6 }),
	maxLength25Rules: (v) =>
		!v || (v && v.replace(/\s+/g, '').length <= 25) || i18n.t('error.maxLength', { number: 25 }),
	maxLength25RulesWithParams: (isSubmitted, content) => [v =>
		!isSubmitted || !v || (v && v.replace(/\s+/g, '').length <= 25) || content],
	maxLength255Rules: (v) =>
		!v || (v && v.replace(/\s+/g, '').length <= 255) || i18n.t('error.maxLength', { number: 255 }),
	emailRules: (v) => !v || /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(v) || i18n.t('error.invalidEmail'),
	emailRulesWithParams: (isSubmitted, content) => [
		v => !isSubmitted || (
			/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(v)
		) || content
	],
	passwordRules: (v) =>
		/^(?!.*\s)(?=.*[A-Z])(?=.*[a-z])(?=.*[0-9])(?=.*[~`!@#$%^&*()--+={}\[\]|\\:;"'<>,.?/_₹]).{8,36}$/.test(
			v
		) || i18n.t('error.validatePassword'),
	passwordRulesWithParams: (isSubmitted, content) => [v => !isSubmitted || /^(?!.*\s)(?=.*[A-Z])(?=.*[a-z])(?=.*[0-9])(?=.*[~`!@#$%^&*()--+={}\[\]|\\:;"'<>,.?/_₹]).{8,36}$/.test(
			v
		) || content],
	urlRules: (v) =>
		/https?:\/\/(www\.)?[-a-zA-Z0-9@:%._\+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()@:%_\+.~#?&//=]*)/.test(
			v
		) || i18n.t('error.urlRequired'),
	expiredDateRules: (v) =>
		/^(0?0[1-9]|1[0-2])\/[1-9]{1}[0-9]{1}$/.test(v) || i18n.t('error.secondInvalidDate'),
	cvvRules: (v) =>
		!v || /^[0-9]{3,4}$/.test(v) || i18n.t('error.invalidCVV'),
	cardNumberRules: (v) =>
		!v || /^[0-9]{15,16}$/.test(v) || i18n.t('error.invalidCardNumber'),
	confirmPasswordRules: (v, password) => v === password || i18n.t('error.confirmPasswordNotMatch'),
	phoneRules: (v) => !v || /^[0-9]{10,11}$/.test(v.replace(/\s+/g, '')) || i18n.t('error.phoneMax10Digits'),
	phoneRulesWithParams: (isSubmitted, content) => [v => !isSubmitted || /^[0-9]{10,11}$/.test(v.replace(/\s+/g, '')) || content],
};
